// extracted by mini-css-extract-plugin
export var android = "AboutSection-module--android--25b3d";
export var app = "AboutSection-module--app--9e9c0";
export var btn = "AboutSection-module--btn--d825a";
export var btnWrapper = "AboutSection-module--btn-wrapper--04c6f";
export var checkboxWrapper = "AboutSection-module--checkbox-wrapper--c595c";
export var checkboxWrapper2 = "AboutSection-module--checkboxWrapper2--1edd3";
export var custom = "AboutSection-module--custom--d4c00";
export var formGroup = "AboutSection-module--form-group--488e5";
export var formWrapper = "AboutSection-module--form-wrapper--b2fd8";
export var goal = "AboutSection-module--goal--cf188";
export var ios = "AboutSection-module--ios--0cd57";
export var links = "AboutSection-module--links--1f087";
export var numbers = "AboutSection-module--numbers--0751f";
export var text = "AboutSection-module--text--6861e";
export var what = "AboutSection-module--what--6f411";
export var wide = "AboutSection-module--wide--07276";
export var wppBtn = "AboutSection-module--wpp-btn--f1433";